// extracted by css-extract-rspack-plugin
var _1 = "dapZe";
var _2 = "evkUo";
var _3 = "qAePI";
var _4 = "BzoU5";
var _5 = "Jc4VX";
export { _1 as "oneRowAttachmentPreviews", _2 as "plusMoreNumber", _3 as "shortWellHeight", _4 as "shortWellLineHeight", _5 as "wellHeight" }
